import $ from 'jquery';

class ModularFinance {
	constructor() {
		this.filters = '';
		this.lazyMinCount = 30;
		this.lazyMaxCount = 30;
		this.lazyOffsetY = 2000;
		this.initListeners();
	}

	initListeners() {
		var self = this;

		$('.mf-filter select').on('change', function () {
			var select = $(this);
			self.retrieveMfnItems(select);
		});
	}

	queryFilters() {
		var self = this;

		self.filters = [];

		$(".mf-filter select option:selected").each(function () {
			let data = {
				'type': $(this).parent().data('type'),
				'value': $(this).val()
			}

			self.filters.push(data);
		});
	}

	retrieveMfnItems(select) {
		var self = this;

		var $parent = $(select).closest('.filter-container');

		self.queryFilters();

		if (self.filters.length == 0) return false;

		var postVars = {
			action: 'mf_retrieveMfnItems',
			nonce: ajax.nonce,
			filters: self.filters,
			mfnType: $parent.find('.mfn_type').val() ?? '',
			mfnCategory: $parent.find('.mfn_category').val() ?? '',
		};

		var $filterResults = $parent.find('.filter-results .post-container');
		var $filterPagination = $parent.find('#page-pagination');

		if ($filterResults.prop('data-requestRunning') == true) {
			return;
		}

		$filterResults.prop('data-requestRunning', true);

		$filterResults.LoadingOverlay("show", {
			imageClass: "overlay_loading_icon",
		});

		$.ajax({
			beforeSend: xhr => {
				xhr.setRequestHeader('X-WP-Nonce', ajax.nonce)
			},
			url: ajax.url,
			method: 'POST',
			data: postVars,
			dataType: 'json',
		}).done(response => {
			var html = '';

			if (response.posts_html) {
				$.each(response.posts_html, function (key, data) {
					html += data;
				});
			} else {
				html = '<h3 class="text-center py-4">' + response.no_posts + '</h3>';
			}

			$filterResults.prop('data-requestRunning', false).fadeIn().html(html);
			$filterPagination.html(response.pagination_html);

			$filterResults.LoadingOverlay("hide", true);
		}).fail(response => {
			$filterResults.LoadingOverlay("hide", true);

			let html = '<h3 class="text-center py-4">' + response.no_posts + '</h3>';
			$filterResults.prop('data-requestRunning', false).fadeIn().html(html);
		});

		return;
	}
}

export default ModularFinance;
